import { render, staticRenderFns } from "./courseCreaterHeaderStep.vue?vue&type=template&id=acb54f5c&scoped=true"
import script from "./courseCreaterHeaderStep.vue?vue&type=script&lang=js"
export * from "./courseCreaterHeaderStep.vue?vue&type=script&lang=js"
import style0 from "./courseCreaterHeaderStep.vue?vue&type=style&index=0&id=acb54f5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acb54f5c",
  null
  
)

export default component.exports